import { render } from "./QuoteThinMobile.vue?vue&type=template&id=516bfbf8&scoped=true"
import script from "./QuoteThinMobile.vue?vue&type=script&lang=js"
export * from "./QuoteThinMobile.vue?vue&type=script&lang=js"

import "./QuoteThinMobile.vue?vue&type=style&index=0&id=516bfbf8&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516bfbf8"]])

export default __exports__